import { useQuery } from '@tanstack/react-query'

export const queryMediaIndex = (params) => { 

    const query = useQuery({
        queryKey: ['get-media-library', params],
        queryFn: async () => {
            const data = await axios.get(`/api/ads/${route().params.ad}/images`, { params });
            return data?.data || [];
        },
    });

    return query;
}

export const queryMediaExtracted = (params) => { 

    const query = useQuery({
        queryKey: ['get-media-library-extracted', params],
        queryFn: async () => {
            const data = await axios.get(`/api/ads/${route().params.ad}/extracted`, { params });
            return data?.data || [];
        },
    });

    return query;
}
